module.exports = __webpack_public_path__ + "img/album02_06.cdf041b7.jpg";